export default __webpack_public_path__ + "static/x87504_267_left_2-6e52c24df9e1171e288bf09ebe90079d.png";